import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/Compare.css";
import SlopeClimb from "../assets/Slope CLimb.png";
import Checkmark from "../assets/checkmark.png";

function Compare() {
  const navigate = useNavigate();

  const handleStartEmpoweredInvesting = () => {
    navigate("/signup");
  };

  return (
    <section className="compare-section">
      <div className="content-wrapper">
        <h2>
          <span>Old School, Automated, or </span>EMPOWERED?
        </h2>
        <div className="compare-container">
          <div className="compare-column">
            <h4>Traditional Advisor</h4>
            <div className="compare-info">
              <p className="compare-info-title">
                &#x274C; <span>Low control</span>
              </p>
              <p>Advisors make decisions for you</p>
            </div>
            <div className="compare-info">
              <p className="compare-info-title">
                {" "}
                &#x274C; <span>High fees</span>
              </p>
              <p>1-2% of your assets, even if you lose money</p>
            </div>
            <div className="compare-info">
              <p className="compare-info-title">
                {" "}
                &#x274C; <span>Conflicted advice</span>
              </p>
              <p>
                Many advisors promote specific funds due to hidden commissions
                or incentives
              </p>
            </div>
          </div>

          <div className="compare-column">
            <h4>Robo-Advisor</h4>
            <div className="compare-info">
              <p className="compare-info-title">⚠️ Limited control</p>
              <p>Platform auto-manages via preset models</p>
            </div>
            <div className="compare-info">
              <p className="compare-info-title">⚠️ Lower fees</p>
              <p>~0.23% AUM + fund fees</p>
            </div>
            <div className="compare-info">
              <p className="compare-info-title">
                ⚠️ Preloaded with preferred ETFs
              </p>
              <p>Often limited to in-house or partner fund options</p>
            </div>
          </div>

          <div className="compare-column">
            <h4>ProfiTree</h4>
            <div className="compare-info">
              <p className="compare-info-title">
                <img src={Checkmark} />
                Complete control
              </p>
              <p>We guide, you decide. No automatid trades</p>
            </div>
            <div className="compare-info">
              <p className="compare-info-title">
                {" "}
                <img src={Checkmark} /> No AUM fees
              </p>
              <p>
                No hidden costs. Just a performance fee based on actual tax
                savings - we win only when you do
              </p>
            </div>
            <div className="compare-info">
              <p className="compare-info-title">
                {" "}
                <img src={Checkmark} />
                No fund affiliations
              </p>
              <p>
                ProfiTree gives unbiased insights based solely on your holdings
              </p>
            </div>
          </div>
        </div>
        <div className="cta-container">
          <button className="compare-cta-button" onClick={handleStartEmpoweredInvesting}>
            Start Empowered Investing
          </button>
        </div>
      </div>
      <img className="slope-climb" src={SlopeClimb} />
    </section>
  );
}

export default Compare;
